module.exports = __webpack_public_path__ + "img/a.b2db2066.jpg";